import React from 'react';
import PrelaunchPage from '../components/landing/PrelaunchPage';

const Prelaunch = () => {
  return <PrelaunchPage />;
};

export default Prelaunch;
